import Vue from "vue";
import Router from "vue-router";
import Layout from "@views/layout/Index";
import { EvaluationRouter } from "./modules/evaluation";
import { PersonalRouter } from "./modules/personal";
import { SystemRouter } from "./modules/system";
import { ManageRouter } from "./modules/manage";

Vue.use(Router);

/**
 * 路由相关属性说明
 * hidden: 当设置hidden为true时，意思不在sideBars侧边栏中显示
 * mete{
 * title: xxx,  设置sideBars侧边栏名称
 * icon: xxx,  设置ideBars侧边栏图标
 * cache: true  当设置为true时不缓存该路由页面
 * }
 */
/*通用routers*/
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/register",
    component: () => import("@/views/login/register"),
    hidden: true
  },
  {
    path: "/create/company",
    component: () => import("@/views/login/CreateCompany"),
    hidden: true
  },
  {
    path: "/join/company",
    component: () => import("@/views/login/JoinCompany"),
    hidden: true
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    hidden: true,
    children: [
      {
        path: "dashboard",
        hidden: true,
        component: () => import("@/views/dashboard/index"),
        name: "Dashboard",
        meta: { title: "Dashboard", icon: "dashboard", affix: true }
      }
    ]
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404"),
    hidden: true
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401"),
    hidden: true
  }
];

export const asyncRoutes = [...EvaluationRouter, ...PersonalRouter, ...SystemRouter, ...ManageRouter];

// 解决addRoute不能删除动态路由问题
export function resetRouter() {
  const reset = creatRouter();
  router.matcher = reset.matcher;
}


const creatRouter = () => {
  return new Router({
    routes: constantRoutes,
    scrollBehavior() {
      return { x: 0, y: 0 };
    }
  });
};

const router = creatRouter();
export default router;


